<template>
  <div v-if="isLoading" class="global-loader-overlay">
    <div class="spinner-container">
      <div class="logo-loader">
        <img :src="darkMode ? logoWhite : logo" alt="TAMEP Logo" class="pulse-logo" />
      </div>
      <div class="loader-text mt-3">Procesando...</div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import logo from "@/assets/img/fondotam-blanco.png";
import logoWhite from "@/assets/img/fondo negro.png";

const store = useStore();
const isLoading = computed(() => store.getters.isLoading);
const darkMode = computed(() => store.state.isDarkMode);
</script>

<style scoped>
.global-loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(4px);
}

.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffffaf;
  padding: 2.5rem 3.5rem;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.logo-loader {
  width: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pulse-logo {
  max-width: 100%;
  animation: pulse-glow 1.5s infinite ease-in-out;
  filter: drop-shadow(0 0 5px rgba(0, 51, 102, 0.3));
}

@keyframes pulse-glow {
  0% {
    transform: scale(0.95);
    opacity: 0.8;
    filter: drop-shadow(0 0 5px rgba(0, 51, 102, 0.3));
  }

  50% {
    transform: scale(1.05);
    opacity: 1;
    filter: drop-shadow(0 0 15px rgba(0, 51, 102, 0.6));
  }

  100% {
    transform: scale(0.95);
    opacity: 0.8;
    filter: drop-shadow(0 0 5px rgba(0, 51, 102, 0.3));
  }
}

.loader-text {
  font-weight: 600;
  color: #344767;
  font-size: 1.1rem;
}

/* Dark mode adjustments */
.dark-version .spinner-container,
.tema-oscuro-azul .spinner-container {
  background-color: #1e1e1e;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
}

.dark-version .loader-text,
.tema-oscuro-azul .loader-text {
  color: #e2e8f0;
}
</style>
